export const environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://api-flex-dev.vk.enbw.com',
  auth: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_ckngZWxZs',
    userPoolClientId: '1maj3d3h6enoqba8c4mp8ul7mq',
  },
}
